import CaseStudySevenContainer from "./containers/CaseStudySevenContainer";
export default CaseStudySevenContainer;
